import { computed } from "vue";
import { useStoreItem } from "../itemStore.store";
import { sceneNodeItemStructure, useSceneNodesStore } from "../scene/sceneNodes.store";
import { useChartStore } from "../charts/charts.store";
import type { SceneChartData } from "./sceneChartData";

export const useSceneChart = useStoreItem(sceneNodeItemStructure, useSceneNodesStore, (sceneNodeRef, sceneNodesStore) => {
  const chart = computed(() => {
    const node = sceneNodeRef.value;
    if (!node) return null;
    const data = node.data as SceneChartData;
    return useChartStore().byUid[data.chartUid];
  });

  return {
    chart
  };
});
